import { gql } from "@apollo/client";

export const GET_ALL_INVOICE_RECEIPT = gql`
  query invoiceReceipts(
    $offset: Int
    $first: Int
    $orderBy: String
    $invoice: String
    $customer: String
    $user: String
  ) {
    invoiceReceipts(
      offset: $offset
      first: $first
      orderBy: $orderBy
      invoice: $invoice
      customer: $customer
      user: $user
    ) {
      totalCount
      edges {
        node {
          objectId
          note
          paidAmount
          paymentType
          deliveryReport
          balance
          invoiceAmount
          createdOn
          packages {
            edges {
              node {
                membershipPackage {
                  package {
                    name
                    objectId
                  }
                }
                personalTrainingPackage {
                  package {
                    objectId
                    name
                  }
                }
                dietPlanPackage {
                  package {
                    name
                    objectId
                  }
                }
              }
            }
          }
          customer {
            user {
              name
              memberInfo {
                objectId
              }
            }
          }
        }
      }
    }
  }
`;
export const GET_SINGLE_INVOICE_RECEIPT = gql`
  query invoiceReceipt($objectId: ID) {
    invoiceReceipt(objectId: $objectId) {
      createdOn
      customer {
        user {
          name
        }
      }
      createdBy {
        name
      }
      paidAmount
      bank {
        name
      }
      chequeAmount
      chequeNo
      chequeDate
      objectId
      paymentType
      invoiceAmount
      deliveryReport
      balance
      customer {
        user {
          name
          memberInfo {
            objectId
          }
        }
      }
      packages {
        edges {
          node {
            membershipPackage {
              package {
                name
                objectId
              }
            }
            personalTrainingPackage {
              package {
                name
                objectId
              }
            }
            dietPlanPackage {
              package {
                name
                objectId
              }
            }
          }
        }
      }
    }
  }
`;
